export enum Pharmacy {
  TAHA = 1,
  CASA_PHARMA = 88566,
  EMPOWER = 61271,
  ZEAL_SPECIALTY = 88432,
}
